(() => {
  'use strict';

  class PdpReviewsList extends HTMLElement {
    connectedCallback() {
      this.toggleBtn = this.querySelector('.pdp-reviews-list__toggle');

      if (!this.toggleBtn) return;

      this.onToggle = this.onToggle.bind(this);
      this.toggleBtn.addEventListener('click', this.onToggle);
    }

    disconnectedCallback() {
      this.toggleBtn?.removeEventListener('click', this.onToggle);
    }

    onToggle() {
      this.setExpanded(!this.classList.contains('is-expanded'));
    }

    setExpanded(expanded) {
      this.classList.toggle('is-expanded', expanded);
      this.toggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      const { labelMore, labelLess } = this.toggleBtn.dataset;
      this.toggleBtn.textContent = expanded ? labelLess : labelMore;
    }
  }

  if (!customElements.get('pdp-reviews-list')) {
    customElements.define('pdp-reviews-list', PdpReviewsList);
  }
})();
